import createReducer from '../utils/createReducer';
import actions from '../actions/brandDetermination';
import {checkBrandDeterminationBtnStatus} from '../utils/validate';


const initialState = {};

const actionHandlers = {
    [actions.HANDLE_BANKING_LOC_FIELD_VALUE_CHANGE](state, {payload}) {
        switch (payload.fieldName) {

            case 'currencySelection': {
                const {supportedCurrenciesAndSites} = state;
                let primarySite = {};

                const selectedCurrencySites = supportedCurrenciesAndSites[payload.fieldValue] || [];
                
                if (selectedCurrencySites.length === 1) {
                    primarySite = selectedCurrencySites[0];
                } 

                return {
                    ...state,
                    currency: payload.fieldValue,
                    primarySite
                };
            } 

            case 'primarySite': return {
                ...state,
                primarySite: payload.fieldValue
            }

            default: return {
                ...state
            };
        }
    },

    [actions.BRAND_DETERMINATION_FIELD_ERROR](state, {payload}) {
        switch (payload.fieldName) {

            case 'currencySelection': return {
                ...state,
                currencyError: payload.msg
            };

            case 'primarySite': return {
                ...state,
                primarySiteError: payload.msg
            }

            default: return {
                ...state
            };
        }
    },

    [actions.TOGGLE_BANKING_LOC_CONTINUE_BUTTON](state, {}) {
        const enableContinueButton = checkBrandDeterminationBtnStatus(state);
        return {
            ...state,
            enableContinueButton
        };
    },

    [actions.BRAND_DETERMINATION_ERROR](state, {payload}) {
        return {
            ...state,
            serviceError: payload.errorKey
        };
    },

    [actions.DISMISS_ALERT_BOX](state, {}) {
        return {
            ...state,
            serviceError: ''
        };
    },

    [actions.GET_SUPPORTED_SITES_SUCCESS](state, {payload}) {
        return {
            ...state,
            supportedCurrenciesAndSites: payload.supportedCurrenciesAndSites,
        };
    },
};

export default createReducer(actionHandlers, initialState);
